import React from 'react'
import PageWrapper from '../../components/PageWrapper'
import ViewActivities from './ViewActivities'
import SkeletonLoader from './SkeletonLoader'
import Metadata from '../../components/Metadata'


  const activitiesMetadata = {
    title: 'Activities - Safelto',
    description: 'View and manage all activities in your estate. Track resident activities, staff activities, and property management activities.',
    keywords: ['activities', 'activity tracking', 'resident activities', 'staff activities', 'property management'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/activities',
    type: 'website' as 'website'
  }

  const Activities = () => {
    const [currentView, setCurrentView] = React.useState('view');
    const [loading, setLoading] = React.useState(true);

    const handleViewSelect = (view: string, queries?: Record<string, string>) => {
      if (view !== currentView) {
        const queryArr = [`active=${view}`];
        if (queries) {
          for (let key in queries) {
            queryArr.push(`${key}=${queries[key]}`);
          }
        }
        window.history.replaceState(null, '', `?${queryArr.join('&')}`);
        setCurrentView(view);
      }
    };

    React.useEffect(() => {
      const searchParams = new URLSearchParams(window.location.search);
      const activeView = searchParams.get('active') || 'view';
      setCurrentView(activeView);
      setLoading(false);
    }, []);

    return (
      <PageWrapper title="Activities" description="View activities here">
        <Metadata {...activitiesMetadata} />
      {loading ? <SkeletonLoader /> : <ViewActivities handleViewSelect={handleViewSelect} />}
    </PageWrapper>
  );
};

export default Activities;
